import { render } from "./KontaktButton.vue?vue&type=template&id=45e4d20c"
import script from "./KontaktButton.vue?vue&type=script&lang=js"
export * from "./KontaktButton.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__